import { IAPIRoutes } from "../../../../config";

export const ConsentRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, POST } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getConsentListAPI: IGetConsentListAPI = async (payload) =>
    GET(
      APIRoutes.apiGetConsentList.replace(
        "{clinic_id}",
        payload.clinic_id?.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const getConsentListDischargeAPI: IGetConsentListAPI = async (payload) =>
    GET(
      APIRoutes.apiGetConsentDischargeList.replace(
        "{clinic_id}",
        payload.clinic_id?.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const setConsentChangeAPI: ISetConsentChangeAPI = async ({
    clinic_id,
    ...obj
  }) =>
    POST(
      APIRoutes.apiPostConsentChange.replace(
        "{clinic_id}",
        clinic_id?.toString()
      ),
      obj,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  return {
    getConsentListAPI,
    getConsentListDischargeAPI,
    setConsentChangeAPI,
  };
};
